module.exports = __webpack_public_path__ + "img/livewell.ab2d6dcf.svg";